import { Facebook, Instagram, Mail, MapPin } from "lucide-react";
import { useLang } from "./LangContext";
import { useSettings, channelLink } from "./SettingsContext";
import { ChapterHead, FadeUp, Soon } from "./Reveal";
import { BranchContactLinks } from "./BranchContactLinks";

const ICONS = {
  instagram: Instagram,
  facebook: Facebook,
  mail: Mail,
};

export default function Contact() {
  const { t } = useLang();
  const { settings } = useSettings();
  const c = t.contact;

  return (
    <section id="iletisim" className="section" data-testid="contact-section">
      <div className="wrap">
        <ChapterHead num={c.num} label={c.label} title={c.title} lead={c.lead} />
        <div className="contact-grid">
          <div className="channel-list">
            {c.channels.map((ch, i) => {
              if (ch.icon === "phone" || ch.icon === "whatsapp") return null;
              const Icon = ICONS[ch.icon];
              const link = channelLink(ch.icon, settings?.contact);
              const Row = link ? "a" : "div";
              return (
                <FadeUp key={ch.label} delay={i * 0.05}>
                  <div data-testid={`contact-channel-${i}`}>
                    <Row
                      className={`channel-row${link ? " is-link" : ""}`}
                      href={link?.href}
                      target={link?.external ? "_blank" : undefined}
                      rel={link?.external ? "noopener noreferrer" : undefined}
                      data-testid={link ? `contact-link-${i}` : undefined}
                    >
                      <span className="icon-chip" aria-hidden="true">
                        <Icon size={19} strokeWidth={2} />
                      </span>
                      <span className="lbl">{ch.label}</span>
                      {link ? (
                        <span className="channel-link" data-testid={`contact-value-${i}`}>
                          {link.text}
                        </span>
                      ) : (
                        <Soon text={c.soon} testid={`contact-soon-${i}`} />
                      )}
                    </Row>
                  </div>
                </FadeUp>
              );
            })}
          </div>
          <div>
            <p className="contact-side-title font-display">{c.branchTitle}</p>
            {t.branches.items.map((branch, i) => (
              <FadeUp key={branch.id} delay={0.08 + i * 0.08}>
                <div className="nap-card" data-testid={`contact-nap-${branch.id}`}>
                  <h3>{branch.name}</h3>
                  <p className="addr">
                    <MapPin size={14} aria-hidden="true" />
                    <span>
                      {branch.lines.map((line) => (
                        <span key={line}>
                          {line}
                          <br />
                        </span>
                      ))}
                    </span>
                  </p>
                  <BranchContactLinks branch={branch} />
                </div>
              </FadeUp>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
